import { ca } from '@cian/analytics';

export const VIEWED_TIMEOUT = 1000;
export enum EBlockName {
  Address = 'show_address_form',
  Advantages = 'show_advantages',
  Included = 'show_what_included',
  Other = 'show_other',
}

export const trackBlockVeiwed = (name: EBlockName) => {
  ca('teaser', {
    product: {
      name,
    },
  });
};

export const trackAddressForm = () => trackBlockVeiwed(EBlockName.Address);
export const trackAdvantages = () => trackBlockVeiwed(EBlockName.Advantages);
export const trackIncluded = () => trackBlockVeiwed(EBlockName.Included);
export const trackOther = () => trackBlockVeiwed(EBlockName.Other);
